import { useFilterContext } from "../FilterContext";
import { updateFilterValueAction } from "../filterState";
import type { FilterValue, TableFilter } from "../filterTypes";
import BooleanFilterEditor from "./BooleanFilterEditor";
import DateFilterEditor from "./DateFilterEditor";
import MultiSelectFilterEditor from "./MultiSelectFilterEditor";
import MultiSelectFilterEditorWithAsyncOptions from "./MultiSelectFilterEditorWithAsyncOptions";
import NumberFilterEditor from "./NumberFilterEditor";
import TextFilterEditor from "./TextFilterEditor";

interface Props {
  filter: TableFilter;
}

const FilterEditor = ({ filter }: Props) => {
  const { setFilterState } = useFilterContext();

  const handleUpdateFilterValue = (newValue: FilterValue) => {
    setFilterState(updateFilterValueAction(filter.id, newValue));
  };

  switch (filter.type) {
    case "text": {
      return <TextFilterEditor filter={filter} onUpdateValue={handleUpdateFilterValue} />;
    }
    case "multi_select": {
      return filter.asyncOptions ? (
        <MultiSelectFilterEditorWithAsyncOptions filter={filter} onUpdateValue={handleUpdateFilterValue} />
      ) : (
        <MultiSelectFilterEditor filter={filter} onUpdateValue={handleUpdateFilterValue} />
      );
    }
    case "number": {
      return <NumberFilterEditor filter={filter} onUpdateValue={handleUpdateFilterValue} />;
    }
    case "date": {
      return <DateFilterEditor showOperator filter={filter} onUpdateValue={handleUpdateFilterValue} />;
    }
    case "boolean": {
      return <BooleanFilterEditor filter={filter} onUpdateValue={handleUpdateFilterValue} />;
    }
  }
};

export default FilterEditor;
